import { createContext, useContext, useState, type ReactNode, type RefObject } from 'react';
import { cx } from '@/lib/format';

type Ctx = { el: HTMLElement | null; ref: RefObject<HTMLElement | null> };
const ScrollCtx = createContext<Ctx>({ el: null, ref: { current: null } });

/**
 * §1.2 — the main region owns the single scroll container. Grids inside it subscribe to its
 * scroll events through this context instead of creating nested scrollers.
 */
export function ScrollContainer({ children, className, id }: { children: ReactNode; className?: string; id?: string }) {
  const [el, setEl] = useState<HTMLElement | null>(null);
  return (
    <ScrollCtx.Provider value={{ el, ref: { current: el } }}>
      <div id={id} ref={setEl} className={cx('grid-scroll relative h-full min-h-0 overflow-y-auto overflow-x-hidden', className)} style={{ overflowAnchor: 'none' }}>
        {children}
      </div>
    </ScrollCtx.Provider>
  );
}

export function useScrollContainer(): HTMLElement | null {
  return useContext(ScrollCtx).el;
}
